import styles from './SlotList.module.scss';
import clsx from 'clsx';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@spotted-zebra-uk/ui-components';

export interface SlotListItem {
  id: string;
  label: string;
}

interface SlotListProps {
  dayLabel: string;
  slots: SlotListItem[];
  selectedSlotId: string | null;
  onSelect: (slotId: string) => void;
  hasPreviousDay: boolean;
  hasNextDay: boolean;
  onPreviousDay: () => void;
  onNextDay: () => void;
}

/** The times on offer for the chosen day, as a radio group of buttons. */
const SlotList: FC<SlotListProps> = ({
  dayLabel,
  slots,
  selectedSlotId,
  onSelect,
  hasPreviousDay,
  hasNextDay,
  onPreviousDay,
  onNextDay,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.list}>
      <span className={styles.dayLabel} id="public-scheduling-day">
        {dayLabel}
      </span>
      {slots.length > 0 ? (
        <div
          role="radiogroup"
          aria-labelledby="public-scheduling-day"
          className={styles.list}
        >
          {slots.map(slot => {
            const picked = slot.id === selectedSlotId;
            return (
              <button
                key={slot.id}
                type="button"
                role="radio"
                aria-checked={picked}
                className={clsx(styles.slot, picked && styles.slotPicked)}
                onClick={() => onSelect(slot.id)}
              >
                {slot.label}
              </button>
            );
          })}
        </div>
      ) : (
        <p className={styles.empty}>{t('publicScheduling.pickADayHint')}</p>
      )}
      <div className={styles.dayNav}>
        <Button
          variant="tertiary"
          size="small"
          disabled={!hasPreviousDay}
          onClick={onPreviousDay}
        >
          {t('publicScheduling.previousDay')}
        </Button>
        <Button
          variant="secondary"
          size="small"
          disabled={!hasNextDay}
          onClick={onNextDay}
        >
          {t('publicScheduling.nextDay')}
        </Button>
      </div>
    </div>
  );
};

export default SlotList;
